import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import Search from 'components/UI/PageSearch'
import KPITable from './components/Table'
import KPICreateModal from '../../Modals/CreateKPIModal'
import RegistersFilter from 'components/UI/PageSearch/filters/RegistersFilter'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
// view components
import { CreateKPIButton } from 'components/CTAs'
// context
import { KPIPageContext } from 'containers/KPIs/Register/layers/API'
// hooks
import { useCurrentUser } from 'hooks/index'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'

const KPI: React.FC = () => {
  const { config, isLoading, pageFilter } = React.useContext(KPIPageContext)

  const {
    permissionsFromSecurityGroups: { createKPI }
  } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Skefto - {pageFilter || 'Indicators'}</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <Search filter={RegistersFilter} />
            {createKPI && <CreateKPIButton />}
          </>
        }>
        <NavigationSidebar config={config} />
        <LayoutContainerInnerWrapper>
          <KPITable />
        </LayoutContainerInnerWrapper>

        <KPICreateModal />
      </MainLayoutContainer>
    </>
  )
}

export default KPI
